export default {
  errorsRootKey: 'ddis',
  resource: 'calltrackings/ddi-numbers',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
